import React from 'react';
import styled from 'styled-components';

export default function DiscountBadge({ className, type, value, isMobile = false, textDisplay = '' }) {
  let specialsText;

  if (textDisplay) {
    specialsText = textDisplay;
  } else if (isMobile) {
    specialsText = type === 'sale' ? `${value}% off` : `$${value} discount!`;
  } else {
    specialsText = type === 'sale' ? `${value}% off` : `$${value} discount applied!`;
  }

  return (
    <Container className={className} type={type}>
      <span>{specialsText}</span>
    </Container>
  );
}

const Container = styled.div`
  display: block;
  width: fit-content;
  height: 19px;
  line-height: 157%;
  border-radius: 34px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
  padding: 0px 10px;
  background-color: ${(props) => (props.type === 'sale' ? '#f3583a' : '#4ca667')};
  margin-bottom: 9px;
  margin-right: 9px;
  font-style: normal;
`;
